import React, { useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import GitHubCalendar from "react-github-calendar";
import { useTranslation } from "react-i18next";

function Github({ username = "saidqodirxon" }) {
  const { t } = useTranslation();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 2022; year <= currentYear; year++) {
    years.push(year);
  }

  const handleYearChange = (year) => {
    setLoading(true);
    setSelectedYear(year);
    setTimeout(() => setLoading(false), 1000);
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <Col md={12} className="text-center mb-4">
        <h1 className="project-heading" style={{ paddingBottom: 20 }}>
          {t("github_contributions_title", "Days I")}{" "}
          <strong className="purple">{t("code", "Code")}</strong>
        </h1>

        {/* Year Selector */}
        <div className="mb-4">
          {years.map((year) => (
            <button
              key={year}
              onClick={() => handleYearChange(year)}
              className={`btn mx-1 ${
                selectedYear === year ? "btn-primary" : "btn-outline-light"
              }`}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: selectedYear === year ? "bold" : "normal",
              }}
            >
              {year}
            </button>
          ))}
        </div>
      </Col>

      <Col md={12} className="d-flex justify-content-center position-relative">
        {loading && (
          <div
            className="position-absolute d-flex align-items-center justify-content-center"
            style={{ top: "50%", zIndex: 10 }}
          >
            <Spinner animation="border" variant="light" />
          </div>
        )}
        <div style={{ opacity: loading ? 0.3 : 1, transition: "opacity 0.3s" }}>
          <GitHubCalendar
            username={username}
            blockSize={15}
            blockMargin={5}
            color="#c084f5"
            fontSize={16}
            year={selectedYear}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Github;
